import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PortfolioCompositionUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.portfolioCompositionData(req);
    }
}
export default PortfolioCompositionUseCase;
